/*
 * Copyright 2018 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {IdleValue} from './IdleValue.mjs';


/**
 * @param {!Object} obj The object to define the property on.
 * @param {string} prop The property name.
 * @param {!Function} init An initialization function to by run idly.
 */
export const defineIdleProperty = (obj, prop, init) => {
  const idleValue = new IdleValue(init);

  Object.defineProperty(obj, prop, {
    configurable: true,
    get: idleValue.getValue.bind(idleValue),
    set: idleValue.setValue.bind(idleValue),
  });
};
